import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* getSmartGroup({ payload: { signal, id, onSuccess } }) {
  try {
    const { data } = yield call(fetch, { api: api.modifiers.smartgroup.get, id, signal });

    yield put(actions.getSmartGroupDone(data.result));

    onSuccess && onSuccess({
      id: data.result.id,
      name: data.result.name,
      query_data: data.result.query_data
    });
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getSmartGroupFailed,
      endpoint: api.modifiers.smartgroup.get.url
    });
  }
}

function* updateSmartGroup({ payload: { id, values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.modifiers.smartgroup.update, id, data: values });

    onSuccess && onSuccess(data.result);
    yield put(actions.updateSmartGroupDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.updateSmartGroupFailed,
      handledErrors,
      endpoint: api.modifiers.smartgroup.update.url
    });
  }
}

export const getSmartGroupSaga = takeEvery(types.GET_SMART_GROUP_REQUEST, getSmartGroup);
export const updateSmartGroupSaga = takeEvery(types.UPDATE_SMART_GROUP_REQUEST, updateSmartGroup);